// extracted by mini-css-extract-plugin
export default {"option":"OptionSelect_option__8GPbU","desabilitar":"OptionSelect_desabilitar__kFAD2","focado":"OptionSelect_focado__T3tqe","novo":"OptionSelect_novo__EVaF7"};